import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Card,
  Container,
  InputAdornment,
  Grid,
  IconButton,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TextField,
  TablePagination,
  Tooltip,
  TableContainer,
  Autocomplete,
} from '@mui/material';
import Page from '../../components/Page';
import ToastError from "../../toast/error/toastError";
import { i18n } from '../../translate/i18n';
import Scrollbar from '../../components/Scrollbar';
import TableRowSkeleton from "../../components/TableRowSkeleton";
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs';
import AccordionSummary from '@mui/material/AccordionSummary';
import CircularProgress from '@mui/material/CircularProgress';
import SearchIcon from '@mui/icons-material/Search';
import { Accordion, AccordionDetails } from './styles';
import FindReplaceIcon from '@mui/icons-material/FindReplace';
import FilterListIcon from '@mui/icons-material/FilterList';
import apiUnitech from '../../services/apiUnidesk';

const initialLoading = {
  fetch: false,
  tags: false
};

const orderByFields = [
  { id: 'NfceAndamento', label: 'NFCE em Andamento' },
  { id: 'NfceAutorizada', label: 'NFCE Autorizada' },
  { id: 'NfceContigencia', label: 'NFCE em Contingência' },
  { id: 'NfeAndamento', label: 'NFE em Andamento' },
  { id: 'NfeAutorizada', label: 'NFE Autorizada' },
  { id: 'NfeContigencia', label: 'NFE em Contingência' },
];

const ordernation = [
  { id: 'asc', label: 'Crescente' },
  { id: 'desc', label: 'Decrescente' },
];

const optionsStatus = [
  { id: true, label: 'Ativo' },
  { id: false, label: 'Inativo' },
];

const ConsultNotes = () => {
  const [loading, setLoading] = useState(initialLoading);
  const [searchParam, setSearchParam] = useState("");
  const [expanded, setExpanded] = useState(false);
  const [registers, setRegisters] = useState([]);
  const [routes, setRoutes] = useState([]);

  const [order, setOrder] = useState(ordernation.find(x => x.id === 'desc'));
  const [orderBy, setOrderBy] = useState(orderByFields.find(x => x.id === 'NfceAndamento'));
  const [routeId, setRouteId] = useState({ id: '', label: 'Todas as Rotas' });
  const [status, setStatus] = useState({ id: true, label: 'Ativo' });
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(40);
  const [selected, setSelected] = useState([]);
  const [count, setCount] = useState(0);

  const handleClickOpenPanel = () => {
    setExpanded(!expanded);
  };

  const handleSearch = (event) => {
    setSearchParam(event.target.value.toLowerCase());
  };

  const loadRoutes = async () => {
    setLoading((prevLoading) => ({ ...prevLoading, tags: true }));
    await apiUnitech.get(`api/rota`, {
      params: {
        api_key: 'gestor_unicheff_ee046272_6f38_4f51_9d12_ef8152a228e1',
      }
    }).then((response) => {
      const allRoutes = response.data?.map((route) => ({
        id: route.Id,
        label: route.Descricao
      }));
      const defaultOption = { id: '', label: 'Todas as Rotas' };
      setRoutes([defaultOption, ...allRoutes]);
      setLoading({ ...loading, tags: false });
    }).catch(err => {
      ToastError(err.response?.data?.message || i18n.t("toastError.defaultError"));
    })
  };

  const loadRegisters = async () => {
    setLoading((prevLoading) => ({ ...prevLoading, fetch: true }));
    setRegisters([]);

    await apiUnitech.get(`api/gerenciamentounitech/getHistoricoAcessos`, {
      params: {
        api_key: 'gestor_unicheff_ee046272_6f38_4f51_9d12_ef8152a228e1',
        nome: searchParam,
        idRota: routeId?.id || '',
        status: status?.id,
        page: page + 1,
        pageSize: rowsPerPage,
        order: `${orderBy.id} ${order.id}`,
      }
    }).then((response) => {
      const { PaginaAtual, TamanhoPagina, TotalRegistros, Dados } = response.data;
      setRegisters(Dados);
      setCount(TotalRegistros);
      setPage(PaginaAtual - 1);
      setRowsPerPage(TamanhoPagina);
      setLoading({ ...loading, fetch: false });
    }).catch(err => {
      ToastError(err.response?.data?.message || i18n.t("toastError.defaultError"));
    })
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    loadRoutes();
  }, []);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      loadRegisters();
    }, 1000);
    return () => clearTimeout(delayDebounceFn);
  }, [searchParam]);

  useEffect(() => {
    loadRegisters();
  }, [page, rowsPerPage]);

  return (
    <div style={{ marginTop: '65px' }}>
      <Page title={i18n.t("mainDrawer.listItems.consultNotes")}>
        <Container maxWidth={false}>
          <HeaderBreadcrumbs
            heading={i18n.t("mainDrawer.listItems.consultNotes")}
            action={<></>}
          />
          <Card>
            <Accordion expanded={expanded}>
              <AccordionSummary
                aria-controls="panel1d-content"
                id="panel1d-header"
              >
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                  <TextField
                    fullWidth
                    sx={{ maxWidth: '300px' }}
                    size="small"
                    type="search"
                    placeholder={i18n.t("consultNotes.searchPlaceholder")}
                    value={searchParam}
                    onChange={handleSearch}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon style={{ color: "gray" }} />
                        </InputAdornment>
                      ),
                    }}
                  />
                  <Tooltip title="Ver Filtros">
                    <IconButton
                      aria-label="delete"
                      color="primary"
                      onClick={() => handleClickOpenPanel()}
                    >
                      <FilterListIcon />
                    </IconButton>
                  </Tooltip>
                </Box>
              </AccordionSummary>
              <AccordionDetails>
                <Box>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={4}>
                      <Autocomplete
                        fullWidth
                        disabled={loading.fetch}
                        id="order-by-autocomplete"
                        size="small"
                        options={orderByFields}
                        getOptionLabel={(option) => option.label}
                        value={orderBy || 'NfceAndamento'}
                        onChange={(event, newValue) => {
                          setOrderBy(newValue);
                        }}
                        disableClearable
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label={i18n.t('consultNotes.filter.orderBy')}
                            placeholder="Ordernar por"
                            variant="outlined"
                            InputLabelProps={{ shrink: true }}
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Autocomplete
                        fullWidth
                        disabled={loading.fetch}
                        id="order-by-autocomplete"
                        size="small"
                        options={ordernation || ''}
                        getOptionLabel={(option) => option.label}
                        value={order}
                        onChange={(event, newValue) => {
                          setOrder(newValue);
                        }}
                        disableClearable
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label={i18n.t('consultNotes.filter.order')}
                            placeholder="Selecione a ordenação"
                            variant="outlined"
                            InputLabelProps={{ shrink: true }}
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Autocomplete
                        fullWidth
                        disabled={loading.fetch}
                        id="route-autocomplete"
                        size="small"
                        options={routes || ''}
                        getOptionLabel={(option) => option.label}
                        value={routeId}
                        onChange={(event, newValue) => {
                          setRouteId(newValue);
                        }}
                        disableClearable
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label={i18n.t('consultNotes.filter.route')}
                            placeholder="Selecione a rota"
                            variant="outlined"
                            InputLabelProps={{ shrink: true }}
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={12} sm={2}>
                      <Autocomplete
                        fullWidth
                        disabled={loading.fetch}
                        id="status-autocomplete"
                        size="small"
                        options={optionsStatus || ''}
                        getOptionLabel={(option) => option.label}
                        value={status}
                        onChange={(event, newValue) => {
                          setStatus(newValue);
                        }}
                        disableClearable
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label={i18n.t('consultNotes.filter.status')}
                            placeholder="Selecione o status"
                            variant="outlined"
                            InputLabelProps={{ shrink: true }}
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={12} md={2}>
                      <Button
                        disabled={loading.fetch}
                        fullWidth
                        variant="outlined"
                        onClick={() => loadRegisters()}
                        endIcon={loading.fetch ? <CircularProgress color="inherit" size={20} /> : <FindReplaceIcon />}>
                        Aplicar filtros
                      </Button>
                    </Grid>
                  </Grid>
                </Box>
              </AccordionDetails>
            </Accordion>
            <Scrollbar>
              <TableContainer sx={{ minWidth: 800 }}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell align="center">{i18n.t("consultNotes.table.contract")}</TableCell>
                      <TableCell align="left">{i18n.t("consultNotes.table.contact")}</TableCell>
                      <TableCell align="left">{i18n.t("consultNotes.table.nfcePending")}</TableCell>
                      <TableCell align="left">{i18n.t("consultNotes.table.nfceAuthorized")}</TableCell>
                      <TableCell align="left">{i18n.t("consultNotes.table.nfceContingency")}</TableCell>
                      <TableCell align="left">{i18n.t("consultNotes.table.nfePending")}</TableCell>
                      <TableCell align="left">{i18n.t("consultNotes.table.nfeAuthorized")}</TableCell>
                      <TableCell align="left">{i18n.t("consultNotes.table.nfeContingency")}</TableCell>
                      <TableCell align="left">{i18n.t("consultNotes.table.route")}</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {registers.map((row) => {
                      const { Id, NfceAndamento, NfceAutorizada, NfceContigencia,
                        NfeAndamento, NfeAutorizada, NfeContigencia, Contato } = row;
                      const isItemSelected = selected.indexOf(Contato.NomeFantasia) !== -1;
                      const routeDescription = routes.find(x => x.id === Contato.IdRota)?.label || '';

                      return (
                        <TableRow
                          hover
                          key={Id}
                          tabIndex={-1}
                          role="checkbox"
                          selected={isItemSelected}
                          aria-checked={isItemSelected}
                        >
                          <TableCell align="left">{Contato.Codigo}</TableCell>
                          <TableCell align="left">{Contato.NomeFantasia}</TableCell>
                          <TableCell align="left"
                            style={{ color: NfceAndamento > 50 ? '#f00' : '#000' }}>
                            {NfceAndamento}</TableCell>
                          <TableCell align="left">{NfceAutorizada}</TableCell>
                          <TableCell align="left">{NfceContigencia}</TableCell>
                          <TableCell align="left"
                            style={{ color: NfeAndamento > 50 ? '#f00' : '#000' }}>
                            {NfeAndamento}</TableCell>
                          <TableCell align="left">{NfeAutorizada}</TableCell>
                          <TableCell align="left">{NfeContigencia}</TableCell>
                          <TableCell align="left">{routeDescription}</TableCell>

                        </TableRow>
                      );
                    })}
                  </TableBody>
                  {loading?.fetch && (
                    <TableBody>
                      <TableRowSkeleton avatar columns={7} />
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </Scrollbar>
            <TablePagination style={{ marginTop: 15 }}
              labelDisplayedRows={({ from, to, count }) => `${i18n.t("userType.translate.result")}: ${count} - ${i18n.t("userType.translate.page")} ${from} ${i18n.t("userType.translate.of")} ${to}`}
              labelRowsPerPage={i18n.t("userType.translate.resultsPerPage")}
              rowsPerPageOptions={[5, 20, 40, 60, 80, 100]}
              component="div"
              count={count}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={(e, page) => setPage(page)}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Card>
        </Container>
      </Page>
    </div>
  );
}

export default ConsultNotes;